export const WIZARD_STEPS = {
	BASIC: 1,
	RULES: 2,
	MAPPING: 3,
	TERMS: 4,
	OVERVIEW: 5,
};

export const WIZARD_STEP_LABELS = {
	[WIZARD_STEPS.BASIC]: "Basic Information",
	[WIZARD_STEPS.RULES]: "Rules & Action",
	[WIZARD_STEPS.MAPPING]: "Mapping",
	[WIZARD_STEPS.TERMS]: "Terms & Conditions",
	[WIZARD_STEPS.OVERVIEW]: "Offer Overview",
};
